import { rem } from 'polished'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import Label from 'LuxKit/Label'
import Pane from 'components/Common/Pane'
import Group from 'components/utils/Group'
import Heading from 'LuxKit/Typography/Heading'
import BodyText from 'LuxKit/Typography/BodyText'
import TextButton from 'LuxKit/Button/TextButton'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { useAppSelector } from 'hooks/reduxHooks'
import { LOYALTY_REWARDS_PAGE } from 'loyalty/constants/loyaltyRoutes'
import LoyaltyRewardsIcon from 'LuxKit/Icons/loyalty/LoyaltyRewardsIcon'
import { isMaldivesCharterCarouselEnabled } from 'selectors/maldivesSelectors'

const Layout = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(16)};
  align-items: stretch;

  ${mediaQueryUp.tablet} {
    flex-direction: row;
    align-items: center;
    gap: ${rem(20)};
  }
`

const Body = styled.div`
  flex: 1 1 auto;
  min-width: 0;
`

const Action = styled.div`
  flex: 0 0 auto;

  ${mediaQueryUp.tablet} {
    align-self: center;
  }
`

function LoyaltyAccountRewardsCard() {
  const intl = useIntl()
  const isMaldivesCharterEnabled = useAppSelector(isMaldivesCharterCarouselEnabled)

  if (!isMaldivesCharterEnabled) return null

  const heading = intl.formatMessage({
    id: 'zpntc30g10RKR6u7Zy5z',
    defaultMessage: 'Société Rewards',
    description: 'Heading on the rewards CTA card shown on the Société account benefits tab',
  })

  const subhead = intl.formatMessage({
    id: 'DDWQnzqsDdtwdj2seOTs',
    defaultMessage: '<strong>The highest-value redemption for your Société points.</strong> Available exclusively on our direct Maldives charter — with strictly limited availability.',
    description: 'Body copy on the rewards CTA card shown on the Société account benefits tab',
  }, {
    strong: chunks => <strong>{chunks}</strong>,
  })

  const buttonLabel = intl.formatMessage({
    id: 'fphcbxTWZhqyjGlxqaU4',
    defaultMessage: 'Learn more',
    description: 'Button label on the rewards CTA card linking to the Société Rewards page',
  })

  const newLabel = intl.formatMessage({
    id: 'Qem0oL3S_cZs4yL2J6h9',
    defaultMessage: 'New',
    description: 'Small badge label on the rewards CTA card shown on the Société account benefits tab',
  })

  return <Pane padding="20 24">
    <Layout>
      <LoyaltyRewardsIcon size={48} colour="highlight-primary-dark" />
      <Body>
        <Group direction="vertical" gap={4}>
          <Group direction="horizontal" gap={4} verticalAlign="center">
            <Heading variant="heading4">{heading}</Heading>
            <Label kind="primary" variant="highlight">{newLabel}</Label>
          </Group>
          <BodyText variant="medium">{subhead}</BodyText>
        </Group>
      </Body>
      <Action>
        <Group direction="horizontal" horizontalAlign="end">
          <TextButton kind="secondary" to={`/${LOYALTY_REWARDS_PAGE}`} fit="mobile-full-width">
            {buttonLabel}
          </TextButton>
        </Group>
      </Action>
    </Layout>
  </Pane>
}

export default LoyaltyAccountRewardsCard
